module.exports = __webpack_public_path__ + "static/media/12.a3e685e8.jpg";